module.exports = __webpack_public_path__ + "img/ad-05.be9d11c8.png";